import React from 'react';
import { string, shape, func } from 'prop-types';
import ClassNames from 'classnames';
import moment from 'moment';
import 'react-dates/initialize';
import { DayPickerSingleDateController } from 'react-dates';
import BaseComponent from '../.internal/BaseComponent';
import Icon from '../icon/Icon';
import 'react-dates/lib/css/_datepicker.css';
import './DatePicker.scss';

export default class DatePicker extends BaseComponent {
  constructor(props) {
    super(props);

    this.dateFormat = 'MM-DD-YYYY';

    this.state = {
      date: moment().format(this.dateFormat)
    };
  }

  onDateChangeHandler = date => {
    const { onChange } = this.props;
    const dateString = moment(date).format(this.dateFormat);

    if (typeof onChange === 'function') {
      onChange(dateString);
    } else {
      this.setState({ date: dateString });
    }
  };

  disableDatesOutsideRange = day => {
    const { minDate, maxDate } = this.props;
    const startOfDay = day.startOf('day');
    const startOfMinDay = moment(minDate).startOf('day');
    const startOfMaxDay = moment(maxDate).startOf('day');

    return (
      (minDate && startOfDay.isBefore(startOfMinDay)) ||
      (maxDate && startOfDay.isAfter(startOfMaxDay))
    );
  };

  render() {
    const { date, style, id, className, onDateFocus } = this.props;

    const componentClasses = ClassNames('date-picker', className);
    const dateValue = typeof date === 'string' ? date : this.state.date;

    return (
      <div id={id} className={componentClasses} style={style}>
        <DayPickerSingleDateController
          date={moment(dateValue, this.dateFormat)}
          focused
          navPrev={
            <div className="date-picker__nav-button date-picker__nav-button--left">
              <Icon className="date-picker__nav-icon" icon="chevronLeft" />
            </div>
          }
          navNext={
            <div className="date-picker__nav-button date-picker__nav-button--right">
              <Icon className="date-picker__nav-icon" icon="chevronRight" />
            </div>
          }
          onDateChange={this.onDateChangeHandler}
          onFocusChange={onDateFocus}
          hideKeyboardShortcutsPanel
          isOutsideRange={this.disableDatesOutsideRange}
        />
      </div>
    );
  }
}

DatePicker.propTypes = {
  date: string,
  className: string,
  minDate: string,
  maxDate: string,
  style: shape({}),
  onChange: func,
  onDateFocus: func,
  onBlur: func
};

DatePicker.defaultProps = {
  date: undefined,
  className: undefined,
  minDate: undefined,
  maxDate: undefined,
  style: undefined,
  onChange: undefined,
  onDateFocus: undefined,
  onBlur: undefined
};
